webpackJsonp([17],{

/***/ "./node_modules/json-loader/index.js!./.cache/json/vue-api-browser-3-build-html-content-negotiation.json":
/***/ (function(module, exports) {

	module.exports = {
		"data": {
			"markdownRemark": {
				"html": "<p>Content negotiation is the process of the server responding to a client’s request for a specific type of representation. You need to write a formatter that makes the HTML version of the resource.</p>\n<p>The <code>HTMLMediaFormatter</code> takes is configured up to add the scripts. When it is invoked it iterates through the in-memory resource and adds the links to the HTML links on the page.</p>\n<p>Note: the injected <code>ApiClientSettings</code> is included below for completeness.</p>\n<Instruction>\n<p>Generate the HTML from the in-memory resource (<code>LinkedRepresentation</code>).</p>\n<div class=\"gatsby-highlight\">\n      <pre class=\"language-csharp\"  path=\"...todo-hypermedia/api/Api/Web/HtmlFormMediaFormatter.cs\"  nocopy=\"false\"><code><span class=\"token keyword\">public</span> <span class=\"token keyword\">class</span> <span class=\"token class-name\">HtmlMediaFormatter</span> <span class=\"token punctuation\">:</span> TextOutputFormatter\n<span class=\"token punctuation\">{</span>\n    <span class=\"token keyword\">private</span> ILogger Log <span class=\"token punctuation\">{</span> <span class=\"token keyword\">get</span><span class=\"token punctuation\">;</span> <span class=\"token punctuation\">}</span>\n\n    <span class=\"token keyword\">private</span> <span class=\"token keyword\">const</span> <span class=\"token keyword\">string</span> ResourceHtml <span class=\"token operator\">=</span> <span class=\"token string\">@\"&lt;html>\n&lt;head>\n  &lt;meta http-equiv=\"\"Content-Type\"\" content=\"\"text/html; charset=utf-8\"\"/>\n  &lt;meta name=\"\"viewport\"\" content=\"\"width=device-width, initial-scale=1\"\">\n  &lt;title>Resource&lt;/title>\n  {0}\n&lt;/head>\n&lt;body>\n  &lt;div id=\"\"app\"\">Intialising ...&lt;/div>\n  {1}\n&lt;/body>\n&lt;/html>\"</span><span class=\"token punctuation\">;</span>\n\n    <span class=\"token keyword\">private</span> <span class=\"token keyword\">readonly</span> List<span class=\"token operator\">&lt;</span><span class=\"token keyword\">string</span><span class=\"token operator\">></span> scripts <span class=\"token operator\">=</span> <span class=\"token keyword\">new</span> <span class=\"token class-name\">List</span><span class=\"token operator\">&lt;</span><span class=\"token keyword\">string</span><span class=\"token operator\">></span><span class=\"token punctuation\">(</span><span class=\"token punctuation\">)</span><span class=\"token punctuation\">;</span>\n\n    <span class=\"token keyword\">public</span> <span class=\"token function\">HtmlFormMediaFormatter</span><span class=\"token punctuation\">(</span>ApiClientSettings configuration<span class=\"token punctuation\">,</span> ILogger log<span class=\"token punctuation\">)</span>\n    <span class=\"token punctuation\">{</span>\n        Log <span class=\"token operator\">=</span> log<span class=\"token punctuation\">;</span>\n        SupportedEncodings<span class=\"token punctuation\">.</span><span class=\"token function\">Add</span><span class=\"token punctuation\">(</span>Encoding<span class=\"token punctuation\">.</span>UTF8<span class=\"token punctuation\">)</span><span class=\"token punctuation\">;</span>\n        SupportedMediaTypes<span class=\"token punctuation\">.</span><span class=\"token function\">Add</span><span class=\"token punctuation\">(</span>MediaTypeNames<span class=\"token punctuation\">.</span>Text<span class=\"token punctuation\">.</span>Html<span class=\"token punctuation\">)</span><span class=\"token punctuation\">;</span>\n\n        scripts<span class=\"token punctuation\">.</span><span class=\"token function\">AddRange</span><span class=\"token punctuation\">(</span>configuration<span class=\"token punctuation\">.</span><span class=\"token function\">ToScriptsHref</span><span class=\"token punctuation\">(</span><span class=\"token punctuation\">)</span><span class=\"token punctuation\">)</span><span class=\"token punctuation\">;</span>\n    <span class=\"token punctuation\">}</span>\n\n    <span class=\"token comment\" spellcheck=\"true\">/// &lt;summary></span>\n    <span class=\"token comment\" spellcheck=\"true\">///     This allows rendering the representations in a browser (with javascript enabled). Because a browser</span>\n    <span class=\"token comment\" spellcheck=\"true\">///     will allow HTML before JSON having all types available as HTML will</span>\n    <span class=\"token comment\" spellcheck=\"true\">///     result in the other data representations trying to be rendered as HTML.</span>\n    <span class=\"token comment\" spellcheck=\"true\">/// &lt;/summary></span>\n    <span class=\"token keyword\">protected</span> <span class=\"token keyword\">override</span> <span class=\"token keyword\">bool</span> <span class=\"token function\">CanWriteType</span><span class=\"token punctuation\">(</span>Type type<span class=\"token punctuation\">)</span>\n    <span class=\"token punctuation\">{</span>\n        <span class=\"token keyword\">return</span> <span class=\"token keyword\">typeof</span><span class=\"token punctuation\">(</span>LinkedRepresentation<span class=\"token punctuation\">)</span><span class=\"token punctuation\">.</span><span class=\"token function\">IsAssignableFrom</span><span class=\"token punctuation\">(</span>type<span class=\"token punctuation\">)</span><span class=\"token punctuation\">;</span>\n    <span class=\"token punctuation\">}</span>\n\n    <span class=\"token keyword\">public</span> <span class=\"token keyword\">override</span> Task <span class=\"token function\">WriteResponseBodyAsync</span><span class=\"token punctuation\">(</span>OutputFormatterWriteContext context<span class=\"token punctuation\">,</span> Encoding selectedEncoding<span class=\"token punctuation\">)</span>\n    <span class=\"token punctuation\">{</span>\n        <span class=\"token keyword\">return</span> context<span class=\"token punctuation\">.</span>HttpContext<span class=\"token punctuation\">.</span>Response<span class=\"token punctuation\">.</span><span class=\"token function\">WriteAsync</span><span class=\"token punctuation\">(</span><span class=\"token keyword\">this</span><span class=\"token punctuation\">.</span><span class=\"token function\">ToHtml</span><span class=\"token punctuation\">(</span>context<span class=\"token punctuation\">)</span><span class=\"token punctuation\">)</span><span class=\"token punctuation\">;</span>\n    <span class=\"token punctuation\">}</span>\n\n    <span class=\"token comment\" spellcheck=\"true\">/// &lt;summary></span>\n    <span class=\"token comment\" spellcheck=\"true\">///     Current implementation supports &lt;see cref = \"LinkedRepresentation\" /> which is on just a wrapper</span>\n    <span class=\"token comment\" spellcheck=\"true\">///     around a resource that when the client receives it then comes back to the server for the JSON</span>\n    <span class=\"token comment\" spellcheck=\"true\">///     representation.</span>\n    <span class=\"token comment\" spellcheck=\"true\">/// &lt;/summary></span>\n    <span class=\"token keyword\">private</span> <span class=\"token keyword\">string</span> <span class=\"token function\">ToHtml</span><span class=\"token punctuation\">(</span>OutputFormatterWriteContext context<span class=\"token punctuation\">)</span>\n    <span class=\"token punctuation\">{</span>\n        <span class=\"token keyword\">if</span> <span class=\"token punctuation\">(</span>context<span class=\"token punctuation\">.</span>Object <span class=\"token keyword\">is</span> LinkedRepresentation<span class=\"token punctuation\">)</span>\n        <span class=\"token punctuation\">{</span>\n            <span class=\"token keyword\">var</span> feed <span class=\"token operator\">=</span> context<span class=\"token punctuation\">.</span>Object <span class=\"token keyword\">as</span> LinkedRepresentation<span class=\"token punctuation\">;</span>\n            <span class=\"token keyword\">return</span> <span class=\"token keyword\">string</span><span class=\"token punctuation\">.</span><span class=\"token function\">Format</span><span class=\"token punctuation\">(</span>ResourceHtml<span class=\"token punctuation\">,</span> <span class=\"token function\">ToHtmlLinks</span><span class=\"token punctuation\">(</span>feed<span class=\"token punctuation\">)</span><span class=\"token punctuation\">,</span> <span class=\"token function\">ToScripts</span><span class=\"token punctuation\">(</span>scripts<span class=\"token punctuation\">)</span><span class=\"token punctuation\">)</span><span class=\"token punctuation\">;</span>\n        <span class=\"token punctuation\">}</span>\n        <span class=\"token keyword\">else</span>\n        <span class=\"token punctuation\">{</span>\n            Log<span class=\"token punctuation\">.</span><span class=\"token function\">Error</span><span class=\"token punctuation\">(</span><span class=\"token string\">\"Unsupported representation\"</span><span class=\"token punctuation\">)</span><span class=\"token punctuation\">;</span>\n        <span class=\"token punctuation\">}</span>\n\n        <span class=\"token keyword\">return</span> <span class=\"token keyword\">string</span><span class=\"token punctuation\">.</span>Empty<span class=\"token punctuation\">;</span>\n    <span class=\"token punctuation\">}</span>\n\n    <span class=\"token keyword\">private</span> <span class=\"token keyword\">string</span> <span class=\"token function\">ToScripts</span><span class=\"token punctuation\">(</span>List<span class=\"token operator\">&lt;</span><span class=\"token keyword\">string</span><span class=\"token operator\">></span> scripts<span class=\"token punctuation\">)</span>\n    <span class=\"token punctuation\">{</span>\n        <span class=\"token keyword\">if</span> <span class=\"token punctuation\">(</span>scripts <span class=\"token operator\">!=</span> <span class=\"token keyword\">null</span><span class=\"token punctuation\">)</span>\n        <span class=\"token punctuation\">{</span>\n            <span class=\"token keyword\">return</span> scripts<span class=\"token punctuation\">.</span><span class=\"token function\">ToString</span><span class=\"token punctuation\">(</span>\n                <span class=\"token string\">\"\"</span><span class=\"token punctuation\">,</span>\n                <span class=\"token string\">\"\"</span><span class=\"token punctuation\">,</span>\n                <span class=\"token string\">\"\\n      \"</span><span class=\"token punctuation\">,</span>\n                script <span class=\"token operator\">=</span><span class=\"token operator\">></span> $<span class=\"token string\">@\"&lt;script src=\"\"{script}\"\">&lt;/script> \"</span><span class=\"token punctuation\">)</span><span class=\"token punctuation\">;</span>\n        <span class=\"token punctuation\">}</span>\n\n        <span class=\"token keyword\">return</span> <span class=\"token keyword\">string</span><span class=\"token punctuation\">.</span>Empty<span class=\"token punctuation\">;</span>\n    <span class=\"token punctuation\">}</span>\n\n\n    <span class=\"token keyword\">private</span> <span class=\"token keyword\">string</span> <span class=\"token function\">ToHtmlLinks</span><span class=\"token punctuation\">(</span>LinkedRepresentation r<span class=\"token punctuation\">)</span>\n    <span class=\"token punctuation\">{</span>\n        <span class=\"token keyword\">if</span> <span class=\"token punctuation\">(</span>r <span class=\"token operator\">!=</span> <span class=\"token keyword\">null</span> <span class=\"token operator\">&amp;&amp;</span> r<span class=\"token punctuation\">.</span>Links <span class=\"token operator\">!=</span> <span class=\"token keyword\">null</span><span class=\"token punctuation\">)</span>\n        <span class=\"token punctuation\">{</span>\n            <span class=\"token keyword\">return</span> r<span class=\"token punctuation\">.</span>Links<span class=\"token punctuation\">.</span><span class=\"token function\">ToString</span><span class=\"token punctuation\">(</span>\n                <span class=\"token string\">\"\"</span><span class=\"token punctuation\">,</span>\n                <span class=\"token string\">\"\"</span><span class=\"token punctuation\">,</span>\n                <span class=\"token string\">\"\\n      \"</span><span class=\"token punctuation\">,</span>\n                link <span class=\"token operator\">=</span><span class=\"token operator\">></span> $<span class=\"token string\">@\"&lt;link rel=\"\"{link.Rel}\"\" href=\"\"{link.HRef}\"\" />\"</span><span class=\"token punctuation\">)</span><span class=\"token punctuation\">;</span>\n        <span class=\"token punctuation\">}</span>\n\n        <span class=\"token keyword\">return</span> <span class=\"token keyword\">string</span><span class=\"token punctuation\">.</span>Empty<span class=\"token punctuation\">;</span>\n    <span class=\"token punctuation\">}</span>\n<span class=\"token punctuation\">}</span>\n</code></pre>\n      </div>\n</Instruction>\n<Instruction>\n<p>Include being able to map the JSON <code>appsettings.json</code> configuration to a class</p>\n<div class=\"gatsby-highlight\">\n      <pre class=\"language-csharp\"  path=\"...todo-hypermedia/api/Api/Web/ApiClientSettings.cs\"  nocopy=\"false\"><code><span class=\"token comment\" spellcheck=\"true\">/// &lt;summary></span>\n<span class=\"token comment\" spellcheck=\"true\">///     Setting for the api client html to pick the external javascript</span>\n<span class=\"token comment\" spellcheck=\"true\">/// &lt;/summary></span>\n<span class=\"token comment\" spellcheck=\"true\">/// &lt;example></span>\n<span class=\"token comment\" spellcheck=\"true\">///</span>\n<span class=\"token comment\" spellcheck=\"true\">///  Development is likely to only have one:</span>\n<span class=\"token comment\" spellcheck=\"true\">///</span>\n<span class=\"token comment\" spellcheck=\"true\">/// &lt;code></span>\n<span class=\"token comment\" spellcheck=\"true\">///    \"Api.Client\":{</span>\n<span class=\"token comment\" spellcheck=\"true\">///         \"Scripts\": [\"dist/api.js\"],</span>\n<span class=\"token comment\" spellcheck=\"true\">///         \"Domain\": \"http://localhost:8080/\"</span>\n<span class=\"token comment\" spellcheck=\"true\">///     }</span>\n<span class=\"token comment\" spellcheck=\"true\">///  &lt;/code></span>\n\n<span class=\"token comment\" spellcheck=\"true\">///  Production may have multiple to allow for Progressive web apps:</span>\n<span class=\"token comment\" spellcheck=\"true\">///</span>\n<span class=\"token comment\" spellcheck=\"true\">/// &lt;code></span>\n<span class=\"token comment\" spellcheck=\"true\">///    \"Api.Client\":{</span>\n<span class=\"token comment\" spellcheck=\"true\">///         \"Scripts\": [\"api.js\", \"vendors~api.js\", \"vendors~api~app.js\"],</span>\n<span class=\"token comment\" spellcheck=\"true\">///         \"Domain\": \"https://api.example.com/\"</span>\n<span class=\"token comment\" spellcheck=\"true\">/// &lt;/code></span>\n<span class=\"token comment\" spellcheck=\"true\">///&lt;/example></span>\n<span class=\"token keyword\">public</span> <span class=\"token keyword\">class</span> <span class=\"token class-name\">ApiClientSettings</span>\n<span class=\"token punctuation\">{</span>\n    <span class=\"token keyword\">public</span> <span class=\"token keyword\">const</span> <span class=\"token keyword\">string</span> SectionName <span class=\"token operator\">=</span> <span class=\"token string\">\"Api.Client\"</span><span class=\"token punctuation\">;</span>\n    <span class=\"token keyword\">public</span> List<span class=\"token operator\">&lt;</span><span class=\"token keyword\">string</span><span class=\"token operator\">></span> Scripts <span class=\"token punctuation\">{</span> <span class=\"token keyword\">get</span><span class=\"token punctuation\">;</span> <span class=\"token keyword\">set</span><span class=\"token punctuation\">;</span> <span class=\"token punctuation\">}</span>\n    <span class=\"token keyword\">public</span> <span class=\"token keyword\">string</span> Domain <span class=\"token punctuation\">{</span> <span class=\"token keyword\">get</span><span class=\"token punctuation\">;</span> <span class=\"token keyword\">set</span><span class=\"token punctuation\">;</span> <span class=\"token punctuation\">}</span>\n\n    <span class=\"token keyword\">public</span> List<span class=\"token operator\">&lt;</span><span class=\"token keyword\">string</span><span class=\"token operator\">></span> <span class=\"token function\">ToScriptsHref</span><span class=\"token punctuation\">(</span><span class=\"token punctuation\">)</span> <span class=\"token operator\">=</span><span class=\"token operator\">></span> Scripts\n        <span class=\"token punctuation\">.</span><span class=\"token function\">Select</span><span class=\"token punctuation\">(</span>script <span class=\"token operator\">=</span><span class=\"token operator\">></span> <span class=\"token keyword\">new</span> <span class=\"token class-name\">Uri</span><span class=\"token punctuation\">(</span><span class=\"token keyword\">new</span> <span class=\"token class-name\">Uri</span><span class=\"token punctuation\">(</span>Domain<span class=\"token punctuation\">)</span><span class=\"token punctuation\">,</span> script<span class=\"token punctuation\">)</span><span class=\"token punctuation\">.</span>AbsoluteUri<span class=\"token punctuation\">)</span>\n        <span class=\"token punctuation\">.</span><span class=\"token function\">ToList</span><span class=\"token punctuation\">(</span><span class=\"token punctuation\">)</span><span class=\"token punctuation\">;</span>\n<span class=\"token punctuation\">}</span>\n</code></pre>\n      </div>\n</Instruction>",
				"fields": {
					"slug": "/vue-api-browser/3-build-html-content-negotiation/"
				},
				"excerpt": "Content negotiation is the process of the server responding to a client’s request for a specific type of representation. You need to write a...",
				"frontmatter": {
					"title": "Generate HTML",
					"videoId": null,
					"videoAuthor": null,
					"parent": "/Users/todd/src/howtohypermedia/content/frontend/vue-api-browser/3-build-html-content-negotiation.md absPath of file",
					"question": "Can an HTML representation include javascript?",
					"answers": [
						"Yes",
						"No",
						"It is mandatory",
						"All of the above"
					],
					"correctAnswer": 0,
					"description": "Learn how to respond as HTML in ASP.NET Core",
					"pageTitle": "How to build HTML as content negotiation"
				}
			},
			"mds": {
				"edges": [
					{
						"node": {
							"frontmatter": {
								"title": "Get started with your favorite technology",
								"description": null
							},
							"fields": {
								"slug": "/choose/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Update Collection Resource",
								"description": "Learn the code mechanics of a edit forms on a collection resource that uses different mime-types"
							},
							"fields": {
								"slug": "/aspnetcore-todo-api/11-update-collection/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "It was great having you!",
								"description": null
							},
							"fields": {
								"slug": "/success/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Update Singleton Resource",
								"description": "Learn the code mechanics of a edit forms on a singleton resource"
							},
							"fields": {
								"slug": "/aspnetcore-todo-api/10-update-singleton/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Introduction",
								"description": "Learn how to build a hypermedia API that works within the constraints of REST"
							},
							"fields": {
								"slug": "/aspnetcore-todo-api/0-introduction/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Getting Started",
								"description": "Learn how to build a hypermedia API "
							},
							"fields": {
								"slug": "/aspnetcore-todo-api/1-getting-started/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "",
								"description": null
							},
							"fields": {
								"slug": "/aspnetcore-todo-api/2-modelling-representations/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Modelling Domain",
								"description": "Learn how to diagram the API textually and get also get visual output"
							},
							"fields": {
								"slug": "/aspnetcore-todo-api/3-modelling-domain-link-relations/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Constructing Representations",
								"description": "Learn the code mechanics of request/response of representation in an MVC framework with the root API representation containing links and a version"
							},
							"fields": {
								"slug": "/aspnetcore-todo-api/4-constructing-representations/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Constructing Collections",
								"description": "Learn the code mechanics of a singleton resource with the user resource"
							},
							"fields": {
								"slug": "/aspnetcore-todo-api/6-constructing-collection/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Constructing Searchable Resources",
								"description": "Learn the code mechanics of a search forms on a collection"
							},
							"fields": {
								"slug": "/aspnetcore-todo-api/8-constructing-search-resources/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Constructing Singletons",
								"description": "Learn the code mechanics of a singleton resource with the user resource"
							},
							"fields": {
								"slug": "/aspnetcore-todo-api/5-constructing-singleton/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Create Resource",
								"description": "Learn the code mechanics of a create forms on a collection"
							},
							"fields": {
								"slug": "/aspnetcore-todo-api/9-create-resource/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Constructing Virtual Resource",
								"description": "Learn the code mechanics of a virtual resource with the user resource"
							},
							"fields": {
								"slug": "/aspnetcore-todo-api/7-constructing-viritual/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Introduction",
								"description": "Learn how to build a todo app and admin functions over the top of a hypermedia API"
							},
							"fields": {
								"slug": "/vue-todo-app/0-introduction/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Client-side URLs and routing",
								"description": "Design your application around the holding and reconstructing client state through the URI in the browser location requires matching client views and the data it requires"
							},
							"fields": {
								"slug": "/vue-todo-app/2-client-side-urls-and-routing/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Getting started",
								"description": "Learn how to build a todo client to use the hypermedia API "
							},
							"fields": {
								"slug": "/vue-todo-app/1-getting-started/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Client-side application cache",
								"description": "Client need to have one copy of representations in the application cache"
							},
							"fields": {
								"slug": "/vue-todo-app/3-application-cache/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Updates and deletes",
								"description": "The application cache also deals with the updates and deletion of resources"
							},
							"fields": {
								"slug": "/vue-todo-app/4-updates-and-deletes/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "On-demand Authentication",
								"description": "Be able to create and renew authentication tokens when the server requests valid authentication tokens"
							},
							"fields": {
								"slug": "/vue-todo-app/5-on-demand-authentication/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Summary",
								"description": "Learn how to build a todo app over the top of a hypermedia API"
							},
							"fields": {
								"slug": "/vue-todo-app/7-summary/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Getting Started",
								"description": "Learn how to build a general purpose client to browse over the API "
							},
							"fields": {
								"slug": "/vue-api-browser/1-getting-started/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Cloning Resources",
								"description": "Forms in hypermedia make cloning of trees straightforward and we can leverage that with drag and drop functionality alongside the client-side application cache"
							},
							"fields": {
								"slug": "/vue-todo-app/6-cloning-resources/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "HTML representation",
								"description": "Learn what and why to build HTML representation of data with code on demand"
							},
							"fields": {
								"slug": "/vue-api-browser/2-build-html-representation/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Introduction",
								"description": "Learn how to build a general purpose client to browse over the API "
							},
							"fields": {
								"slug": "/vue-api-browser/0-introduction/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Generate HTML",
								"description": "Learn how to respond as HTML in ASP.NET Core"
							},
							"fields": {
								"slug": "/vue-api-browser/3-build-html-content-negotiation/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Register text/html",
								"description": "Learn how to respond to HTML content negotiation in ASP.NET Core"
							},
							"fields": {
								"slug": "/vue-api-browser/4-register-html-content-negotiation/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "GET application/json",
								"description": "Learn how to request JSON from the client"
							},
							"fields": {
								"slug": "/vue-api-browser/5-request-json/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Summary",
								"description": "Learn how to user hypermedia as engine to navigate an API and make changes"
							},
							"fields": {
								"slug": "/vue-api-browser/10-summary/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Displaying with interaction",
								"description": "Learn how to process JSON to make delete, create and update"
							},
							"fields": {
								"slug": "/vue-api-browser/6-displaying-with-interaction/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Displaying forms",
								"description": "Learn how to process form values for create and edit forms"
							},
							"fields": {
								"slug": "/vue-api-browser/8-displaying-form-values/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Deleting a resource",
								"description": "Learn how to process JSON to try and delete a resource"
							},
							"fields": {
								"slug": "/vue-api-browser/7-try-delete-representation/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Introduction",
								"description": "Learn all about hypermedia and why a REST-style of architecture is simple and subtle. It's not really for the lazy or those who like to be clever."
							},
							"fields": {
								"slug": "/basics/0-introduction/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Minimally layered design",
								"description": "Learn why hypermedia is a thin layer across persistence that should guide us through the business problem."
							},
							"fields": {
								"slug": "/basics/1-minimally-layered-design/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Submitting forms",
								"description": "Learn how to process creates (POST) and updates (PUT) on a resource"
							},
							"fields": {
								"slug": "/vue-api-browser/9-submitting-forms/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Big Picture (Trends)",
								"description": "Learn that distributed applications have trended towards data and business logic being processed at the client edge"
							},
							"fields": {
								"slug": "/basics/3-big-picture/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Hypermedia for the dedicated",
								"description": "Learn some techniques that will ease the server and client development"
							},
							"fields": {
								"slug": "/basics/4-for-the-dedicated/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Navigating a hypermedia API",
								"description": "Learn what a hypermedia looks like to be able to explore a domain."
							},
							"fields": {
								"slug": "/basics/2-navigating-api/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Multiple clients",
								"description": "Learn that most APIs should have multiple types of clients."
							},
							"fields": {
								"slug": "/advanced/0-multiple-clients/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "API Modelling",
								"description": "Learn about how collections and singletons are modelled in hypermedia"
							},
							"fields": {
								"slug": "/advanced/1-api-modelling/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Forms Modelling",
								"description": "Links and Forms are used to update resources and controlled by the server that the client then uses"
							},
							"fields": {
								"slug": "/advanced/2-forms-modelling/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Common Questions",
								"description": "Answer common questions about these tutorials"
							},
							"fields": {
								"slug": "/advanced/4-common-questions/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Todo Domain",
								"description": "Learn about domain of the API"
							},
							"fields": {
								"slug": "/advanced/3-todo-domain/"
							}
						}
					}
				]
			}
		},
		"pathContext": {
			"slug": "/vue-api-browser/3-build-html-content-negotiation/"
		}
	};

/***/ })

});


// WEBPACK FOOTER //
// path---vue-api-browser-3-build-html-content-negotiation-d4355fdc9455ed303ac4.js